import React from "react";
import { motion } from "framer-motion";

const coachImage =
  "https://images.unsplash.com/photo-1656653121526-a1458317b790?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtYXJ0aWFsJTIwYXJ0cyUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NDAzOTI4OXww&ixlib=rb-4.1.0&q=85";

const stats = [
  { k: "3 Dan", v: "Karate Shotokan" },
  { k: "20+ ani", v: "Experiență" },
  { k: "Multiplu", v: "Campion Național" },
  { k: "Internațional", v: "Podium" },
];

const CoachSpotlight = () => {
  return (
    <section
      id="antrenor"
      className="section border-t border-[rgba(242,235,229,0.1)] relative overflow-hidden"
      data-testid="coach-section"
    >
      <div className="container-brutal grid grid-cols-12 gap-6 md:gap-10">
        {/* Left: eyebrow + copy */}
        <div className="col-span-12 md:col-span-5 flex flex-col justify-between">
          <div>
            <span className="eyebrow">§ 04 / Sensei</span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="section-title mt-8 flex items-start gap-6"
            >
              <span>
                Șoș<br />Eric<span className="text-[#D91604]">.</span>
              </span>
              <motion.div
                initial={{ opacity: 0, scale: 0.6, rotate: -30 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 1, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="hidden md:block w-20 h-20 lg:w-24 lg:h-24 rounded-full overflow-hidden bg-white ring-2 ring-[#D91604] shrink-0 mt-3"
              >
                <img
                  src="https://customer-assets.emergentagent.com/job_elite-karate-3d/artifacts/17qa70pq_sigla%20club%202015-1.webp"
                  alt="Elite Center Hunedoara"
                  className="w-full h-full object-cover scale-[1.06]"
                />
              </motion.div>
            </motion.h2>

            <p className="eyebrow mt-4 text-[#D91604]" data-testid="coach-subtitle">
              Maestru Emerit al Sportului
            </p>

            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              className="editorial-lead mt-10 italic max-w-lg"
            >
              „Nu antrenez copii să câștige. Îi antrenez să nu piardă cine sunt.
              Karate începe și se termină cu <span className="text-[#D91604] not-italic font-anton">respect</span>.&rdquo;
            </motion.p>

            <p className="mt-6 text-sm text-[#8a8a8a] max-w-md leading-relaxed">
              Antrenor 3 Dan Karate Shotokan, cu peste două decenii de tatami.
              Multiplu campion național și internațional. Formator de campioni,
              dar înainte de toate — formator de caracter.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-px bg-[rgba(242,235,229,0.1)] mt-16 border border-[rgba(242,235,229,0.1)]">
            {stats.map((s) => (
              <div key={s.k} className="bg-[#050505] p-5">
                <div className="font-anton text-2xl md:text-3xl text-[#D91604]">{s.k}</div>
                <div className="eyebrow mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: clipped frame image */}
        <div className="col-span-12 md:col-span-7 md:pl-6">
          <div className="relative">
            <motion.div
              initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
              whileInView={{ clipPath: "inset(0% 0% 0% 0%)" }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.4, ease: [0.65, 0.05, 0.36, 1] }}
              className="relative aspect-[4/5] overflow-hidden clip-frame border border-[rgba(242,235,229,0.15)]"
            >
              <img
                src={coachImage}
                alt="Șoș Eric — Antrenor Karate Shotokan"
                className="w-full h-full object-cover photo-editorial"
                data-testid="coach-image"
              />
              {/* Spotlight gradient */}
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,transparent_20%,rgba(5,5,5,0.55)_75%,rgba(5,5,5,0.9)_100%)]" />
              {/* Corner labels */}
              <div className="absolute top-4 left-4 flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D91604]" />
                <span className="eyebrow text-[#f2ebe5]">REC · 2025</span>
              </div>
              <div className="absolute bottom-4 right-4 text-right">
                <div className="eyebrow text-[#f2ebe5]/80">SENSEI</div>
                <div className="font-anton text-2xl leading-none mt-1">ȘOȘ ERIC</div>
              </div>
              {/* Japanese overlay */}
              <div className="absolute top-6 right-6 font-jp text-6xl md:text-8xl text-[#D91604]/70 leading-none pointer-events-none select-none">
                先生
              </div>
            </motion.div>

            {/* Caption */}
            <div className="flex items-center justify-between mt-4">
              <span className="text-xs text-[#8a8a8a] tracking-widest uppercase">
                Fig. 001 — Sensei Șoș Eric, Dojo Hunedoara
              </span>
              <span className="text-xs text-[#8a8a8a] font-jp">押忍</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoachSpotlight;
